import type { TFunction } from "i18next";
import type { SupportedLanguage } from "@/i18n";

const APP_TITLE_KEYS: Record<string, string> = {
  electrical: "meta.title_electrical",
  electrical_us: "meta.title_electrical_us",
  plumbing: "meta.title_plumbing",
  ibew_aptitude: "meta.title_ibew_aptitude",
};

export function getDocumentTitle(t: TFunction, appToBuild: string): string {
  const key = APP_TITLE_KEYS[appToBuild];
  if (!key) return t("meta.title_default");
  return t(key);
}

export function getOgLocale(language: SupportedLanguage): string {
  return language === "es" ? "es_ES" : "en_US";
}
